export default __webpack_public_path__ + "static/media/delete_light.69419d02.svg";